<wd-privacy-settings></wd-privacy-settings>
<div fxLayout="row" fxLayoutAlign="center center" class="m-t-15">
  <button color="primary" type="button" mat-flat-button (click)="close()" i18n="general|accept@@geneal_accept">Accept</button>
</div>
